// extracted by mini-css-extract-plugin
export default {"fileUpload":"styles_fileUpload__UTf8L","dropZone":"styles_dropZone__as8Ek"};